<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner"  title="Women Wellness Program" subtitle="Women Wellness Program" ></app-page-banner>
        <!-- INNER PAGE BANNER END -->
        <!-- <app-page-banner 
        title="Our Mission" 
        subtitle="Our Mission"
        backgroundImage="assets/images/missionn.jpg">
      </app-page-banner> -->
      

        <!-- FAQ SECTION START -->
        <!-- <app-faqs [faqs]="faqs"></app-faqs> -->
        <!-- FAQ SECTION END -->

        <!-- FORM SECTION START -->
        <!-- <app-faq-form></app-faq-form> -->
        <!-- FORM ONE SECTION END -->
      <div class="container pb-5">
       
        <div class="row align-items-center">

            <div class="col-lg-6 col-md-6">
                <div class="text-content ">
                    
                    <h5>Program Structure: </h5>
                    <p>
                        Women Wellness Program at Soul Space is an initiative especially crafted to
                        empower women by addressing their overall well-being. The program nurtures
                        women’s emotional, physical, mental and social health providing them a safe and
                        supportive environment. This facilitates women to explore strategies to enhance their

                        health by rediscovering balance, building resilience and celebrating the strength
                        within.
                    </p>
                    <div>&nbsp;</div>
                    <h5>Women’s Wellness Program at Soul Space stand out Key Features: </h5>
                    <ul class="centered-list">
                        <p><b>Physical Health and Vitality:</b></p>
                       <li>Customized Fitness Routines - With our tailored daily fitness routines, yoga
                        classes and movement workshops designed for all levels, we promote
                            physical health and vitality.</li>
        
                    </ul>
                    </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="about-image">
                            

                            <img src="assets/images/multi-ethnic-group-of-confident-mature-women-bondi-2023-11-27-05-34-15-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                            height: 450px;
                            width: 100%;
                            margin-bottom: 15px;
                        ">
                        </div>
                     

                    </div>
      
        
            <!-- Right Side: Text Content -->
            <div class="col-lg-12 col-md-12">
                <div class="text-content" style="margin-top: -17px;">
                    <ul class="centered-list">
                        <li> Healthy Living Guidance - Customized and easy-to-follow guidance on
                            healthy lifestyle and maintaining a balanced diet, to fuel your <span style="margin-left: 25px;">body and
                            enhance your vitality.</span></li>
                        <li>Proactive Health Awareness - Discussions, insights and resources to dive into
                        learning more about women's health issues and tips  <span style="margin-left: 25px;">for preventive care and
                            wellbeing.</span></li>
                        <br>
                       <p><b>Mental and Emotional Wellbeing:</b></p> 
                        <li> Empowering Workshops - Interactive and thought provoking sessions
                        designed to build emotional resilience, boost self-confidence <span style="margin-left: 25px;">and master
                        stress management.</span></li>
                        <li> Mindfulness and Relaxation Techniques - Promoting calmness and mental
                        clarity through mindfulness, guided mediation, and tools <span style="margin-left: 25px;">to restore inner
                        peace.</span></li>
                        <li>Peer Support Circle - A safe and secure space to connect with each other,
                        share experiences, fostering a sense of community.</li>
                        <br>
                        <p><b>Social Growth and Connection:</b></p>
                        <li> Community Building Activities - Building connections in the groups through
                        interactive discussions and activities to strengthen social <span style="margin-left: 25px;">bonds and
                        relationships..</span></li>
                        <li>  Community Engagement - Fostering a sense of purpose and belongingness
                        through participation in the initiatives aimed to empower <span style="margin-left: 25px;">women or make a
                        change in the society.</span></li>
                        <br>
                        <p><b>Holistic and Personalized Approach:</b></p>
                        <li>  Flexibility - A program designed with tailored activities and resources to meet
                        everyone’s needs and fit into their lifestyles.</li>
                        <li> Work-Life Balance - In addition to prioritizing your own wellness the program
                        helps one navigate the demands of everyday life by <span style="margin-left: 25px;">equipping one with
                        strategies.</span></li>
                        <br>
                        <p>The Women Wellness Program at Soul Space is not just an initiative, rather your
                        opportunity and our commitment to empower women and foster healthier, happier
                        and more connected lives. So join our Women Wellness Program - because the
                        World thrives when Women thrive.</p>
                    </ul>
                    <br>
                    <h5>Program Framework:</h5>
                    
                    <ul class="centered-list">
                        <p><b>Initial Wellness Assessment:</b></p>
                       <li> Physical and emotional health evaluations.</li>
                       <li> Goal-setting for personal and professional aspirations.</li>
                       <br>
                       <p><b>Core Weekly Activities:</b></p>
                        <li>Virtual sessions: Yoga & meditation, emotional wellness workshops.</li> 
                        <li> In-person sessions: Dynamic yoga and group emotional counseling.</li>
                        <br>
                        <p><b>Supportive Features:</b></p>
                        <li>Personalized wellness plans, community building, and a resource library.</li>
                   </ul>
                   
                    <h5>Evidence-Based Approach:</h5>
                    <ul class="centered-list">
                    <!-- <p>
                        How We Do It:</p> -->
                       <li>Psychological Evaluations: Structured tools, behavioral observations, and
                        data-driven analysis.</li>
                        <li> Interventions: Counseling, Cognitive Behavioral Therapy (CBT), mindfulness
                        practices, and workshops.</li>
                    </ul>
                    <h5>Program Benefits:</h5>
                    <ul class="centered-list">
                    <li>
                         Physical health: Improved strength and flexibility.</li>
                         <li> Mental clarity: Reduced stress and improved focus.</li>
                        <li> Emotional resilience: Tools to handle challenges effectively.</li>
                        <li> Community support: A network of women on a shared journey.</li>
                    </ul>
                </div>
            </div>
        </div>
        
    </div>
               

    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>